import React from 'react';
import {
  PlanningPhaseSelector,
  getPlanningPhasePortalPath,
} from 'alakai-aloha-shared/public-ui/planning-selector';
import { getPlanningPortalNavigationPath } from '../../features/homepage-planning/planningPhasePortals';
import { getRuntimeSiteContext } from '../../lib/siteContext';
import { trackEvent } from '../../utils/analytics';

export default function PlanningPhasePromo({
  pageType,
  className = '',
}) {
  const { island, islandConfig } = React.useMemo(() => getRuntimeSiteContext(), []);
  const analyticsContext = React.useMemo(() => ({
    island_key: island,
    surface: 'content_footer',
    source_page_type: pageType,
  }), [island, pageType]);

  const getPhaseHref = React.useCallback((phase) => {
    const path = getPlanningPhasePortalPath(phase.id);
    return path ? getPlanningPortalNavigationPath(path, island) : '/';
  }, [island]);

  const handlePhaseChange = React.useCallback((phase) => {
    trackEvent(phase ? 'planning_phase_select' : 'planning_phase_clear', {
      ...analyticsContext,
      phase_id: phase?.id,
      phase_order: phase?.order,
    });
  }, [analyticsContext]);

  return (
    <div className={`max-w-6xl mx-auto px-4${className ? ` ${className}` : ''}`}>
      <PlanningPhaseSelector
        islandKey={island}
        islandName={islandConfig.shortTitle}
        surface="content-footer"
        headingLevel={2}
        getPhaseHref={getPhaseHref}
        onPhaseChange={handlePhaseChange}
        onExploreResources={(phase) => trackEvent('planning_resources_click', {
          ...analyticsContext,
          phase_id: phase.id,
          phase_order: phase.order,
        })}
        onImpression={() => trackEvent('planning_selector_impression', analyticsContext)}
      />
    </div>
  );
}
